module.exports = __webpack_public_path__ + "img/liushui (6).0f82a1ba.png";